import { DownArrowIcon } from 'assets';
import React from 'react';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { themeEnum } from 'shared/utils/Enum';
function CustomSelect({
    disabled,
    label,
    required,
    error,
    value,
    onChangeHandle,
    ContainerStyle,
    selectionColor,
    options,
    IconStyle,
    InputContainerStyle,
    placeholder,
    OptionsContainer,
    LabelStyle,
    MainContainerStyle,
    optionText,
    Id
}) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [openSelection, setOpenSelection] = useState(false);
    const [toggleSelection, setToggleSelection] = useState(false);
    const handleClick = (e) => {
        let elem = document.getElementById('optionsContainer');
        let CommponentElem = document.getElementById(Id);
        if (elem) {
            if (!CommponentElem?.contains(e.target)) {
                setOpenSelection?.(false);
            } else if (!CommponentElem?.contains(e.target) && !elem?.contains(e.target)) {
                setOpenSelection?.(false);
            }
        }
    };

    useEffect(() => {
        document.body.addEventListener(
            'click',
            (event) => {
                handleClick(event);
            },
            true
        );
        return () => {
            document.body.removeEventListener(
                'click',
                (event) => {
                    handleClick(event);
                },
                true
            );
        };
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        setToggleSelection(openSelection);
    }, [openSelection]);

    return (
        <div className={classNames(MainContainerStyle && MainContainerStyle, 'position-relative mb-3 w-100')} role={'button'}>
            <div className="d-flex flex-column">
                {label && (
                    <label className={classNames(`${theme}FontColor`, styles.InputLabel, LabelStyle && LabelStyle)}>
                        {label} {!!required && <label className={styles.Asterik}>*</label>} {!!optionText && <span className={classNames(styles.OptionText)}>{optionText}</span>}
                    </label>
                )}
                <div
                    id={Id}
                    className={classNames(InputContainerStyle && InputContainerStyle, styles.InputContainer, `${theme}ModalBackground`)}
                    onClick={() => {
                        if (!disabled) {
                            let toggle = !toggleSelection;
                            setToggleSelection(toggle);
                            setOpenSelection(toggle);
                        }
                    }}
                >
                    {value?.label ? (
                        <label
                            role={'button'}
                            className={classNames(` ${theme}FontColor`, `${ContainerStyle && ContainerStyle}`, styles.SelectionPlaceLabel, `${theme}ModalBackground`)}
                            style={value === '' && !disabled ? { color: '#808191' } : value !== '' && disabled ? { color: '#808191' } : { color: selectionColor }}
                        >
                            {value?.img ? <img src={value?.img} className={classNames(styles.OptionImg)} /> : null}
                            {value?.label ? value?.label : placeholder}
                        </label>
                    ) : (
                        <label
                            role={'button'}
                            className={classNames(` ${theme}FontColor`, `${ContainerStyle ? ContainerStyle : styles.SelectionPlaceHolder}`, `${theme}ModalBackground`)}
                            style={value === '' && !disabled ? { color: '#808191' } : value !== '' && disabled ? { color: '#808191' } : { color: selectionColor }}
                        >
                            {placeholder}
                        </label>
                    )}

                    <DownArrowIcon className={classNames(`${theme}SvgIcon`)} />
                </div>
            </div>
            <div
                className={`${OptionsContainer ? OptionsContainer : themeEnum.Dark === theme ? styles.OptionsContainerDark : styles.OptionsContainerLight}`}
                style={openSelection ? { display: 'flex' } : { display: 'none' }}
                id="optionsContainer"
            >
                <div className={classNames(styles.OptionChildContainer)}>
                    {options?.length ? (
                        <>
                            <label
                                onClick={() => {
                                    onChangeHandle?.(null);
                                    document.body.removeEventListener(
                                        'click',
                                        (event) => {
                                            handleClick(event);
                                        },
                                        true
                                    );
                                    setOpenSelection(false);
                                }}
                                className={classNames(`${themeEnum.Dark === theme ? styles.OptionLabelDark : styles.OptionLabelSelected} p-3`)}
                                style={{
                                    borderBottomColor: '#E4E4E4',
                                    borderTopRightRadius: '14px',
                                    borderTopLeftRadius: '14px'
                                }}
                            >
                                Please Select
                            </label>{' '}
                            {options?.map((opt, ind) => {
                                return (
                                    <label
                                        onClick={() => {
                                            onChangeHandle?.(opt);
                                            document.body.removeEventListener(
                                                'click',
                                                (event) => {
                                                    handleClick(event);
                                                },
                                                true
                                            );
                                            setOpenSelection(false);
                                        }}
                                        key={ind}
                                        className={classNames(`${themeEnum.Dark === theme ? styles.OptionLabelDark : styles.OptionLabelLight} p-3`)}
                                        style={
                                            ind === options?.length - 1
                                                ? {
                                                      borderBottomColor: 'transparent',
                                                      borderBottomRightRadius: '14px',
                                                      borderBottomLeftRadius: '14px'
                                                  }
                                                : { borderBottomColor: '#E4E4E4' }
                                        }
                                    >
                                        {opt?.img ? <img src={opt?.img} className={classNames(styles.OptionImg)} /> : null}
                                        {opt?.label}
                                    </label>
                                );
                            })}
                        </>
                    ) : (
                        <label
                            onClick={() => {
                                onChangeHandle?.(null);
                                document.body.removeEventListener(
                                    'click',
                                    (event) => {
                                        handleClick(event);
                                    },
                                    true
                                );
                                setOpenSelection(false);
                            }}
                            className={classNames(`${themeEnum.Dark === theme ? styles.OptionLabelDark : styles.OptionLabelLight} p-3`)}
                            style={{
                                borderBottomColor: 'transparent',
                                borderBottomRightRadius: '14px',
                                borderBottomLeftRadius: '14px'
                            }}
                        >
                            Not Found
                        </label>
                    )}
                </div>
            </div>
            {!!error && <div className="Error">{error}</div>}
        </div>
    );
}

export default CustomSelect;
